import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { Calendar, MapPin, Users, Heart, Share2 } from 'lucide-react';

const TripCard = ({ trip, onToggleFavorite, isFavorite }) => {
  const handleFavoriteClick = (e) => {
    e.preventDefault();
    onToggleFavorite(trip._id);
  };

  return (
    <div className="card hover:shadow-lg transition-shadow">
      <div className="flex justify-between items-start mb-4">
        <h3 className="text-lg font-semibold text-gray-900 truncate">{trip.name}</h3>
        <div className="flex space-x-2">
          <button
            onClick={handleFavoriteClick}
            className={`p-1 rounded-full ${isFavorite ? 'text-red-500' : 'text-gray-400'} hover:text-red-500`}
          >
            <Heart className={`h-5 w-5 ${isFavorite ? 'fill-current' : ''}`} />
          </button>
          {trip.isPublic && (
            <Share2 className="h-5 w-5 text-blue-500" />
          )}
        </div>
      </div>

      <p className="text-gray-600 text-sm mb-4 line-clamp-2">{trip.description}</p>

      <div className="space-y-2 mb-4">
        <div className="flex items-center text-sm text-gray-500">
          <Calendar className="h-4 w-4 mr-2" />
          <span>
            {format(new Date(trip.startDate), 'MMM dd')} - {format(new Date(trip.endDate), 'MMM dd, yyyy')}
          </span>
        </div>
        
        <div className="flex items-center text-sm text-gray-500">
          <MapPin className="h-4 w-4 mr-2" />
          <span>{trip.totalDays} days</span>
        </div>

        {trip.participants.length > 0 && (
          <div className="flex items-center text-sm text-gray-500">
            <Users className="h-4 w-4 mr-2" />
            <span>{trip.participants.length + 1} travelers</span>
          </div>
        )}
      </div>

      <div className="flex justify-between items-center">
        <div className="flex items-center space-x-2">
          <img
            src={`https://ui-avatars.com/api/?name=${trip.owner.name}&size=24&background=3b82f6&color=fff`}
            alt={trip.owner.name}
            className="w-6 h-6 rounded-full"
          />
          <span className="text-sm text-gray-600">{trip.owner.name}</span>
        </div>
        
        <Link
          to={`/trips/${trip._id}`}
          className="btn-primary text-sm"
        >
          View Trip
        </Link>
      </div>
    </div>
  );
};

export default TripCard;